
namespace Gamification.Gamification {
    export class UtentiColumns {
        static columnsKey = 'Gamification.Utenti';
    }
}